import { render, staticRenderFns } from "./realFooter.vue?vue&type=template&id=9e3e1b9a&scoped=true"
import script from "./realFooter.vue?vue&type=script&lang=js"
export * from "./realFooter.vue?vue&type=script&lang=js"
import style0 from "./realFooter.vue?vue&type=style&index=0&id=9e3e1b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3e1b9a",
  null
  
)

export default component.exports